export default function headerDirective(DataService, MapService) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/header/header-template.html",
		scope: {
			id: "<",
			type: "@",
			heading: "@",
			typeClickable: "=",
			onTypeClick: "&?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function ($scope) {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				$scope.$watch(() => (vm.id), vm.update);
			};

			vm.update = () => {
				vm.color = MapService.getColor(vm.type);
				DataService.getOrg(vm.id, vm.type).then((org) => {
					vm.org = org;
				});
			};
		}
	};
}
